import { useRef, useState } from 'react';
import type { OSSAssetsType } from '@/type/common';
import {
    getOSSPolicy,
    getCategoryListWithCreate,
    getCategoryListWithQuery,
    getGCSPolicy,
} from '@/api/common';
import { getClassifyTree } from '@/api/systemSetting';
import type { TreeProps } from 'antd/es/tree';

import { debounce } from 'lodash';

// const interval = 10 * 60 * 1000;
const interval = 3 * 60 * 1000;

const useFormData = () => {
    // 文件上传认证信息
    const [OSSData, setOSSData] = useState<OSSAssetsType>();
    const [GCSToken, setGCSToken] = useState<string>();
    const refreshTask = useRef<NodeJS.Timer | null>();
    // 工单分类
    const [AlltreeData, setAllTreeData] = useState<{
        create?: TreeProps['treeData'];
        query?: TreeProps['treeData'];
        all?: TreeProps['treeData'];
    }>();
    const [getTreeDataTime, setGetTreeDataTime] = useState<number>(0);

    const getOSSAssets = debounce(async (isRefresh = false) => {
        if (OSSData && !isRefresh) {
            return;
        }

        if (!refreshTask.current) {
            const task = setInterval(() => {
                refreshOSSAssets();
            }, interval);

            refreshTask.current = task;
        }

        const result = await getOSSPolicy();
        if (result) {
            setOSSData(result);
        }
    }, 1000);

    const getGCSToken = debounce(async () => {
        const result = await getGCSPolicy();
        setGCSToken(result);
    }, 1000);

    const refreshOSSAssets = debounce(() => {
        getOSSAssets(true);
    }, 5000);

    const handleTreeData = (
        tree: DivideClassify[],
        { isTreeSelect = false, multiple = false },
    ): any => {
        return tree.map((item: DivideClassify) => {
            let disabled = false;

            if (
                isTreeSelect &&
                ((item.childList?.length > 0 && !multiple) || item.level === 1)
            ) {
                disabled = true;
            }

            return {
                ...item,
                disabled,
                childList: item.childList
                    ? handleTreeData(item?.childList, {
                          isTreeSelect,
                          multiple,
                      })
                    : [],
            };
        });
    };

    const getClassifyTreeInfo = debounce(
        async (
            scene: 'create' | 'query' | 'all' = 'all',
            otherParams: {
                isPopLandTab?: number;
                isTreeSelect?: boolean;
                multiple?: boolean;
            } | null,
        ) => {
            const { isPopLandTab, isTreeSelect, multiple } = otherParams || {};

            const now = new Date().getTime();

            // 如果有数据 直接返回,大于半小时请求 刷新下数据
            if (
                AlltreeData?.[scene]?.length &&
                now - getTreeDataTime < 30 * 60 * 1000
            ) {
                setTreeData(
                    scene,
                    handleTreeData(AlltreeData?.[scene] || [], {
                        isTreeSelect,
                        multiple,
                    }),
                );
                return;
                // return AlltreeData?.[scene];
            }

            setGetTreeDataTime(now);

            if (scene === 'create') {
                const data = await getCategoryListWithCreate({
                    isPopLandTab,
                });
                setTreeData(
                    scene,
                    handleTreeData(data || [], { isTreeSelect, multiple }),
                );
                return data;
            } else if (scene === 'query') {
                const data = await getCategoryListWithQuery({
                    isPopLandTab: otherParams?.isPopLandTab,
                });
                setTreeData(
                    scene,
                    handleTreeData(data || [], { isTreeSelect, multiple }),
                );
                return data;
            } else {
                const data = await getClassifyTree();
                setTreeData(
                    scene,
                    handleTreeData(data || [], { isTreeSelect, multiple }),
                );
                return data;
            }
        },
        500,
    );

    const setTreeData = (
        key: 'create' | 'query' | 'all' = 'all',
        data: TreeProps['treeData'],
    ) => {
        const treeData = {
            ...AlltreeData,
            [key]: data,
        };
        setAllTreeData(treeData);
    };

    // const clearTreeData = () => {
    //     console.log('-=-=-=clearTreeData');
    //     setAllTreeData(undefined);
    // };

    return {
        OSSData,
        GCSToken,
        getOSSAssets,
        getGCSToken,
        getClassifyTreeInfo,
        treeData: AlltreeData,
        // setTreeData,
        // clearTreeData,
    };
};

export default useFormData;
